import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { EventsInfo } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;
// const setUrl = (url: string)=>{
//   url = `${url}?${queryParams.toString()}`
//   return url
// };

// 查询活动详情
// 接口文档：https://cooper.didichuxing.com/docs2/document/2203888774537
// export function getEventsInfo () {
//   return request.get<EventsInfo>(`${baseUrl}${setUrl('/sofipo/v0/marketing/user/detail')}`, {})
// }

export function getEventsInfo(params: { activityType: number }): Promise<EventsInfo> {
  return request.post<EventsInfo>(`${baseUrl}/sofipo/v0/marketing/user/detail`, params);
}
